const Tactic = require('../../entities/Tactic');
const { Age }  = require("../Constants");
const TacticNames = require("../Names/TacticNames");

class FightingBand extends Tactic {
    constructor() {
        super(
            Age.Age1,
            TacticNames.FightingBand,
            [2, 0, 0],
            "1",
            {}
        )
    }
}

module.exports = FightingBand;